import React from "react";
import { ArrowLeft } from "lucide-react";
import styles from "./GestionModuleHeader.module.scss";
import { GESTION_SECTION_QUERY_TO_LABEL, type ProfileGestionSection } from "../../../../utils/navigationHelpers.ts";

interface GestionModuleHeaderProps {
  section: ProfileGestionSection;
  onBackToHub: () => void;
}

const GestionModuleHeader: React.FC<GestionModuleHeaderProps> = ({ section, onBackToHub }) => {
  return (
    <header className={styles.header}>
      <h1 className={styles.title}>{GESTION_SECTION_QUERY_TO_LABEL[section]}</h1>
      <button type="button" className={styles.backButton} onClick={onBackToHub}>
        <ArrowLeft size={18} aria-hidden />
        Volvel al menú
      </button>
    </header>
  );
};

export default GestionModuleHeader;
